import Vue from 'vue'
import App from './App.vue'
import "./assets/fonts/font.css"

Vue.config.productionTip = false
import {
    Button,
    Sidebar,
    SidebarItem,
    Field,
    Divider,
    Notify,
    Uploader,
    Image as VanImage,
    Slider
} from 'vant';

Vue
    .use(Button)
    .use(Sidebar)
    .use(SidebarItem)
    .use(Field)
    .use(Divider)
    .use(Notify)
    .use(Uploader)
    .use(Uploader)
    .use(VanImage)
    .use(Slider)
new Vue({
    render: h => h(App),
}).$mount('#app')
